{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Shopify-integráció törlése",
        "MESSAGE": "Biztosan törölni szeretné a Shopify-integrációt?"
      },
      "STORE_URL": {
        "TITLE": "Shopify-bolt csatlakoztatása",
        "LABEL": "Bolt URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Adja meg a Shopify-bolt myshopify.com URL-jét",
        "CANCEL": "Mégse",
        "SUBMIT": "Bolt csatlakoztatása"
      },
      "ERROR": "Hiba történt a Shopifyhoz való csatlakozáskor. Próbálja újra, vagy ha a hiba továbbra is fennáll, forduljon az ügyfélszolgálathoz."
    },
    "HEADER": "Integrációk",
    "DESCRIPTION": "A kontaktközpont számos eszközzel és szolgáltatással integrálható, hogy csapata hatékonyabban dolgozzon. Az alábbi listában beállíthatja kedvenc alkalmazásait.",
    "LEARN_MORE": "További információ az integrációkról",
    "LOADING": "Integrációk betöltése",
    "CAPTAIN": {
      "DISABLED": "A Captain nincs engedélyezve a fiókjában.",
      "CLICK_HERE_TO_CONFIGURE": "Kattintson ide a beállításhoz",
      "LOADING_CONSOLE": "A Captain konzol betöltése...",
      "FAILED_TO_LOAD_CONSOLE": "Nem sikerült betölteni a Captain konzolt. Frissítse az oldalt, és próbálja újra."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Feliratkozott események",
      "LEARN_MORE": "További információ a webhookokról",
      "FORM": {
        "CANCEL": "Mégse",
        "DESC": "A webhook események valós idejű információt adnak arról, hogy mi történik a fiókjában. Kérjük, a visszahívás beállításához adjon meg egy érvényes URL-t.",
        "SUBSCRIPTIONS": {
          "LABEL": "Események",
          "EVENTS": {
            "INBOX_CREATED": "Postafiók létrehozva",
            "CONVERSATION_CREATED": "Beszélgetés létrehozva",
            "CONVERSATION_STATUS_CHANGED": "Beszélgetés státusza megváltozott",
            "CONVERSATION_UPDATED": "Beszélgetés frissítve",
            "MESSAGE_CREATED": "Üzenet létrehozva",
            "MESSAGE_UPDATED": "Üzenet frissítve",
            "WEBWIDGET_TRIGGERED": "A felhasználó által megnyitott élő chat widget",
            "CONTACT_CREATED": "Kontakt létrehozva",
            "CONTACT_UPDATED": "Kontakt frissítve",
            "JARABOT_EVENT": "Belső események"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Példa: {webhookExampleURL}",
          "ERROR": "Kérjük helyes URL-t adj meg"
        },
        "EDIT_SUBMIT": "Webhook frissítése",
        "ADD_SUBMIT": "Webhook létrehozása"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Beállítások",
      "HEADER": "Webhook beállítások",
      "HEADER_BTN_TXT": "Új webhook hozzáadása",
      "LOADING": "Kapcsolódó Webhookok betöltése",
      "SEARCH_404": "Nincs megfelelő elem",
      "SIDEBAR_TXT": "<p><b>Webhook</b>-ok</p><p>A webhookok HTTP visszahívások, amelyek minden fiókhoz beállíthatók. Események, például üzenetek létrehozása aktiválhatják a webhookokat. Több webhookot is beállíthat a fiókjához. <br /><br /> Egy <b>webhook</b> létrehozásához kattintson a <b>Webhook hozzáadása</b> gombra. A meglévő webhookokat a Törlés gombra kattintva törölheti.</p>",
      "LIST": {
        "404": "Nincs a fiókhoz rendelt Webhook.",
        "TITLE": "Webhook kezelés",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook végpont",
          "ACTIONS": "Műveletek"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Szerkesztés",
        "TITLE": "Webhook szerkesztése",
        "API": {
          "SUCCESS_MESSAGE": "A Webhook konfigurációja sikeresen frissítve",
          "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
        }
      },
      "ADD": {
        "CANCEL": "Mégse",
        "TITLE": "Új webhook hozzáadása",
        "API": {
          "SUCCESS_MESSAGE": "A Webhook konfigurációja sikeresen hozzáadva",
          "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Törlés",
        "API": {
          "SUCCESS_MESSAGE": "Webhook sikeresen törölve",
          "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
        },
        "CONFIRM": {
          "TITLE": "Törlés megerősítése",
          "MESSAGE": "Biztosan törölni szeretnéd a webhookot? ({webhookURL})",
          "YES": "Igen, Törlés ",
          "NO": "Nem, tartsa meg"
        }
      },
      "DISABLED_BADGE": "Letiltva",
      "DISABLED_REASON": "{count} egymást követő hiba után automatikusan letiltva. Utolsó hiba: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Engedélyezés",
        "API": {
          "SUCCESS_MESSAGE": "A webhook engedélyezése sikeres",
          "ERROR_MESSAGE": "Nem sikerült engedélyezni a webhookot, próbálja újra később"
        }
      }
    },
    "SLACK": {
      "DELETE": "Törlés",
      "DELETE_CONFIRMATION": {
        "TITLE": "Az integráció törlése",
        "MESSAGE": "Biztos, hogy törölni szeretné az integrációt? Ha így tesz, elveszíti a Slack munkaterületén lévő beszélgetésekhez való hozzáférést."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "Ezzel az integrációval minden bejövő beszélgetés szinkronizálódik a Slack-munkaterület ***{selectedChannelName}*** csatornájába. Az ügyfélbeszélgetéseket közvetlenül a csatornában kezelheti, így egyetlen üzenetről sem marad le.\n\nAz integráció fő funkciói:\n\n**Válasz a beszélgetésekre a Slackből:** Ha válaszolni szeretne egy beszélgetésre a ***{selectedChannelName}*** Slack-csatornában, írja meg az üzenetet, és küldje el szálként. A kontaktközpont a választ eljuttatja az ügyfélnek. Ennyi az egész!\n\n **Privát jegyzetek létrehozása:** Ha válasz helyett privát jegyzetet szeretne létrehozni, kezdje az üzenetet a ***`note:`*** előtaggal. Így az üzenet privát marad, és az ügyfél nem látja.\n\n**Ügynökprofil társítása:** Ha a Slacken válaszoló személynek ugyanazzal az e-mail-címmel van ügynökprofilja a kontaktközpontban, a válaszok automatikusan ehhez az ügynökprofilhoz kapcsolódnak. Így könnyen követheti, ki mit és mikor írt. Ha a válaszolónak nincs társított ügynökprofilja, a válaszok az ügyfél számára a bot profiljából jelennek meg.",
        "SELECTED": "kiválasztás"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Csatorna kiválasztása",
        "UPDATE": "Frissítés",
        "BUTTON_TEXT": "Csatlakozás a csatornához",
        "DESCRIPTION": "A Slack-munkaterülete mostantól össze van kapcsolva a kontaktközponttal. Az integráció azonban jelenleg inaktív. Az integráció aktiválásához és egy csatorna csatlakoztatásához kattintson az alábbi gombra.\n\n**Figyelem:** Ha egy privát csatornát próbál csatlakoztatni, akkor adja hozzá alkalmazásunkat a Slack-csatornához, mielőtt ezt a lépést folytatná.",
        "ATTENTION_REQUIRED": "Figyelem szükséges",
        "EXPIRED": "A Slack integráció lejárt. Ha továbbra is szeretne üzeneteket kapni a Slacken, törölje az integrációt, és csatlakoztassa újra a munkaterületét."
      },
      "UPDATE_ERROR": "Hiba történt az integráció frissítésében, kérjük, próbálja újra",
      "UPDATE_SUCCESS": "A csatorna sikeresen csatlakozott",
      "FAILED_TO_FETCH_CHANNELS": "Hiba történt a csatornák lekérdezésében a Slackből, kérjük, próbálja meg újra"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI segítség",
      "WITH_AI": " {option} AI segítségével ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Válasz lehetőségek",
        "SUMMARIZE": "Összefoglalás",
        "REPHRASE": "Írás fejlesztése",
        "FIX_SPELLING_GRAMMAR": "Helyesírás és nyelvtan kijavítása",
        "SHORTEN": "Rövidítés",
        "EXPAND": "Kiegészítés",
        "MAKE_FRIENDLY": "Legyen személyes hangvételű",
        "MAKE_FORMAL": "Legyen hivatalos hangvételű",
        "SIMPLIFY": "Egyszerűsít",
        "TRANSLATE": "Fordítás",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Fordítás a többségi nyelvre"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Vázlatos szöveg",
        "GENERATED_TITLE": "Generált szöveg",
        "AI_WRITING": "AI éppen ír",
        "BUTTONS": {
          "APPLY": "Használja ezt a javaslatot",
          "CANCEL": "Mégse"
        }
      },
      "CTA_MODAL": {
        "TITLE": "OpenAI-al integrálás",
        "DESC": "Az OpenAI GPT modelljeivel fejlett AI funkciókat építhet be a menüjébe. A kezdéshez adja meg az API kulcsot az OpenAI-fiókjából.",
        "KEY_PLACEHOLDER": "Adja meg az OpenAI API kulcsát",
        "BUTTONS": {
          "NEED_HELP": "Kell segítség?",
          "DISMISS": "Elutasítás",
          "FINISH": "Előkészületek befejezése"
        },
        "DISMISS_MESSAGE": "Az OpenAI integrációt később is beállíthatja, amikor csak akarja.",
        "SUCCESS_MESSAGE": "OpenAI integráció sikeres beállítva"
      },
      "TITLE": "Javítás AI segítségével",
      "SUMMARY_TITLE": "Összegzés Al segítségével",
      "REPLY_TITLE": "Válasz a javaslatra az AI-val",
      "SUBTITLE": "\nA jelenlegi piszkozat alapján továbbfejlesztett válasz jön létre mesterséges intelligencia használatával.",
      "TONE": {
        "TITLE": "Hangnem",
        "OPTIONS": {
          "PROFESSIONAL": "Professzionális",
          "FRIENDLY": "Barátságos"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generálás",
        "GENERATING": "Generálás...",
        "CANCEL": "Mégse"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Integráció sikeresen törölve"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Kapcsolódás"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Kezdőlap applikációi",
      "HEADER_BTN_TXT": "Új kezdőlapi applikáció hozzáadása",
      "SIDEBAR_TXT": "<p><b>Irányítópult-alkalmazások</b></p><p>Az irányítópult-alkalmazások segítségével a szervezetek beágyazhatnak egy alkalmazást az irányítópultba, hogy kontextust biztosítsanak az ügyfélszolgálati ügynökök számára. Ezzel a funkcióval önállóan hozhat létre alkalmazást, és beágyazhatja azt az irányítópultba, hogy megadja a felhasználói információkat, rendeléseiket vagy korábbi fizetési előzményeiket.</p><p>Ha beágyazza alkalmazását az irányítópultba, az alkalmazás ablakeseményként kapja meg a beszélgetés és a kapcsolatfelvétel kontextusát. Helyezzen el egy figyelőt az üzeneteseményhez az oldalon, hogy megkapja a kontextust.</p><p>Új irányítópult-alkalmazás hozzáadásához kattintson az „Új irányítópult-alkalmazás hozzáadása” gombra.</p>",
      "DESCRIPTION": "Az irányítópult-alkalmazások segítségével a szervezetek beágyazhatnak egy alkalmazást az irányítópultba, hogy kontextust biztosítsanak az ügyfélszolgálati ügynökök számára. Ez a funkció lehetővé teszi, hogy önállóan hozzon létre egy alkalmazást, és beágyazza azt, hogy megadja a felhasználói információkat, rendeléseiket vagy korábbi fizetési előzményeiket.\n",
      "LEARN_MORE": "További információ az irányítópult-alkalmazásokról",
      "LIST": {
        "404": "Ebben a fiókban még nincsenek konfigurálva kezdőlapi-alkalmazások",
        "LOADING": "Kezdőlapi alkalmazások lekérése...",
        "TABLE_HEADER": {
          "NAME": "Név",
          "ENDPOINT": "Végpont"
        },
        "EDIT_TOOLTIP": "App szerkesztése",
        "DELETE_TOOLTIP": "App törlése"
      },
      "FORM": {
        "TITLE_LABEL": "Név",
        "TITLE_PLACEHOLDER": "Add meg a kezdőlapi applikáció nevét",
        "TITLE_ERROR": "A kezdőlapi applikáció nevének megadása kötelező",
        "URL_LABEL": "Végpont",
        "URL_PLACEHOLDER": "Add meg azt a végpont URL-jét, ahol az alkalmazást tárolják",
        "URL_ERROR": "Érvényes URL megadása kötelező"
      },
      "CREATE": {
        "HEADER": "Új kezdőlapi applikáció hozzáadása",
        "FORM_SUBMIT": "Elküldés",
        "FORM_CANCEL": "Mégse",
        "API_SUCCESS": "Kezdőlapi applikációk sikeresen konfigurálva",
        "API_ERROR": "Nem tudtuk megjeleníteni az appot, kérlek próbáld újra"
      },
      "UPDATE": {
        "HEADER": "Kezdőlapi app szerkesztése",
        "FORM_SUBMIT": "Frissítés",
        "FORM_CANCEL": "Mégse",
        "API_SUCCESS": "Kezdőlapi applikációk sikeresen frissítve",
        "API_ERROR": "Nem tudtuk frissíteni az appot, kérlek próbáld újra"
      },
      "DELETE": {
        "CONFIRM_YES": "Igen, töröld",
        "CONFIRM_NO": "Nem, tartsd meg",
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztosan törölni szeretnéd az appot? ({appName}?",
        "API_SUCCESS": "Kezdőlapi applikációk sikeresen törölve",
        "API_ERROR": "Nem tudtuk törölni az appot, kérlek próbáld újra"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Linear-feladat létrehozása/csatolása",
      "LOADING": "Linear-feladatok betöltése...",
      "LOADING_ERROR": "Hiba történt a Linear-feladatok betöltésekor, próbálja újra",
      "CREATE": "Létrehozás",
      "LINK": {
        "SEARCH": "Feladatok keresése",
        "SELECT": "Feladat kiválasztása",
        "TITLE": "Összekapcsolás",
        "EMPTY_LIST": "Nem található Linear-feladat",
        "LOADING": "Betöltés",
        "ERROR": "Hiba történt a Linear-feladatok betöltésekor, próbálja újra",
        "LINK_SUCCESS": "A feladat csatolása sikeres",
        "LINK_ERROR": "Hiba történt a feladat csatolásakor, próbálja újra",
        "LINK_TITLE": "Beszélgetés (#{conversationId}) – {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Linear-feladat létrehozása/csatolása",
        "DESCRIPTION": "Hozzon létre Linear-feladatokat a beszélgetésekből, vagy csatoljon meglévőket az egyszerű követéshez.",
        "FORM": {
          "TITLE": {
            "LABEL": "Cím",
            "PLACEHOLDER": "Adja meg a címet",
            "REQUIRED_ERROR": "Cím megadása kötelező"
          },
          "DESCRIPTION": {
            "LABEL": "Leírás",
            "PLACEHOLDER": "Adja meg a leírást"
          },
          "TEAM": {
            "LABEL": "Csapat",
            "PLACEHOLDER": "Csapat kiválasztása",
            "SEARCH": "Csapat keresése",
            "REQUIRED_ERROR": "A csapat megadása kötelező"
          },
          "ASSIGNEE": {
            "LABEL": "Hozzárendelt",
            "PLACEHOLDER": "Felelős kiválasztása",
            "SEARCH": "Felelős keresése"
          },
          "PRIORITY": {
            "LABEL": "Prioritás",
            "PLACEHOLDER": "Prioritás megadása",
            "SEARCH": "Prioritás keresése"
          },
          "LABEL": {
            "LABEL": "Cimke",
            "PLACEHOLDER": "Címke kiválasztása",
            "SEARCH": "Címke keresése"
          },
          "STATUS": {
            "LABEL": "Státusz",
            "PLACEHOLDER": "Státusz kiválasztása",
            "SEARCH": "Státusz keresése"
          },
          "PROJECT": {
            "LABEL": "Projekt",
            "PLACEHOLDER": "Projekt kiválasztása",
            "SEARCH": "Projekt keresése"
          }
        },
        "CREATE": "Létrehozás",
        "CANCEL": "Mégse",
        "CREATE_SUCCESS": "A feladat létrehozása sikeres",
        "CREATE_ERROR": "Hiba történt a feladat létrehozásakor, próbálja újra",
        "LOADING_TEAM_ERROR": "Hiba történt a csapatok betöltésekor, próbálja újra",
        "LOADING_TEAM_ENTITIES_ERROR": "Hiba történt a csapat adatainak betöltésekor, próbálja újra"
      },
      "ISSUE": {
        "STATUS": "Státusz",
        "PRIORITY": "Prioritás",
        "ASSIGNEE": "Hozzárendelt",
        "LABELS": "Cimkék",
        "CREATED_AT": "Létrehozva: {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Leválasztás",
        "SUCCESS": "A feladat leválasztása sikeres",
        "ERROR": "Hiba történt a feladat leválasztásakor, próbálja újra"
      },
      "DELETE": {
        "TITLE": "Biztosan törölni szeretné az integrációt?",
        "MESSAGE": "Biztosan törölni szeretné az integrációt?",
        "CONFIRM": "Igen, törlés",
        "CANCEL": "Mégse"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "További információ",
    "COPILOT": {
      "SEND_MESSAGE": "Üzenet elküldése...",
      "EMPTY_MESSAGE": "Hiba történt a válasz generálása során. Kérjük, próbálja újra.",
      "LOADER": "A Captain gondolkodik",
      "YOU": "Ön",
      "USE": "Használat",
      "RESET": "Visszaállítás",
      "SELECT_ASSISTANT": "Asszisztens kiválasztása"
    },
    "PAYWALL": {
      "TITLE": "Váltson magasabb csomagra a Captain AI használatához",
      "AVAILABLE_ON": "A Captain nem érhető el az ingyenes csomagban.",
      "UPGRADE_PROMPT": "Váltson magasabb csomagra, és férjen hozzá az asszisztensekhez, a copilothoz és további funkciókhoz.",
      "UPGRADE_NOW": "Váltás most",
      "CANCEL_ANYTIME": "A csomagját bármikor módosíthatja vagy lemondhatja"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "A Captain AI funkció csak fizetős csomagban érhető el.",
      "UPGRADE_PROMPT": "Váltson magasabb csomagra, és férjen hozzá az asszisztensekhez, a copilothoz és további funkciókhoz.",
      "ASK_ADMIN": "A csomagváltáshoz forduljon a rendszergazdához."
    },
    "BANNER": {
      "RESPONSES": "Felhasználta a válaszkeret több mint 80%-át. A Captain AI további használatához váltson magasabb csomagra.",
      "DOCUMENTS": "Elérte a dokumentumkorlátot. A Captain AI további használatához váltson magasabb csomagra."
    },
    "FORM": {
      "CANCEL": "Mégse",
      "CREATE": "Létrehozás",
      "EDIT": "Frissítés"
    },
    "ASSISTANTS": {
      "HEADER": "Asszisztensek",
      "ADD_NEW": "Új asszisztens létrehozása",
      "DELETE": {
        "TITLE": "Biztosan törölni szeretné az asszisztenst?",
        "DESCRIPTION": "Ez a művelet végleges. Az asszisztens törlésével eltávolítja azt az összes csatlakoztatott postafiókból, és véglegesen törli az összes generált tudást.",
        "CONFIRM": "Igen, törlés",
        "SUCCESS_MESSAGE": "Az asszisztens törlése sikeres",
        "ERROR_MESSAGE": "Hiba történt az asszisztens törlésekor, próbálja újra."
      },
      "FORM_DESCRIPTION": "Az alábbi adatokkal adjon nevet az asszisztensnek, írja le a célját, és adja meg a terméket, amelyet támogatni fog.",
      "CREATE": {
        "TITLE": "Asszisztens létrehozása",
        "SUCCESS_MESSAGE": "Az asszisztens létrehozása sikeres",
        "ERROR_MESSAGE": "Hiba történt az asszisztens létrehozásakor, próbálja újra."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Asszisztens neve",
          "PLACEHOLDER": "Adjon nevet az asszisztensnek",
          "ERROR": "Adja meg az asszisztens nevét"
        },
        "DESCRIPTION": {
          "LABEL": "Asszisztens leírása",
          "PLACEHOLDER": "Írja le, hogyan és hol fogja használni ezt az asszisztenst",
          "ERROR": "A leírás megadása kötelező"
        },
        "PRODUCT_NAME": {
          "LABEL": "Termék neve",
          "PLACEHOLDER": "Adja meg a termék nevét, amelyhez az asszisztens készül",
          "ERROR": "A termék nevének megadása kötelező"
        },
        "FEATURES": {
          "TITLE": "Lehetőségek",
          "ALLOW_CONVERSATION_FAQS": "GYIK generálása a megoldott beszélgetésekből",
          "ALLOW_MEMORIES": "A fontos részletek megjegyzése az ügyfél-interakciókból."
        }
      },
      "EDIT": {
        "TITLE": "Asszisztens frissítése",
        "SUCCESS_MESSAGE": "Az asszisztens frissítése sikeres",
        "ERROR_MESSAGE": "Hiba történt az asszisztens frissítésekor, próbálja újra."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Asszisztens szerkesztése",
        "DELETE_ASSISTANT": "Asszisztens törlése",
        "VIEW_CONNECTED_INBOXES": "Csatlakoztatott postafiókok"
      },
      "EMPTY_STATE": {
        "TITLE": "Nincs elérhető asszisztens",
        "SUBTITLE": "Hozzon létre egy asszisztenst, amely gyors és pontos válaszokat ad a felhasználóknak. A súgócikkekből és a korábbi beszélgetésekből tanul.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain asszisztens",
          "NOTE": "A Captain asszisztens közvetlenül kommunikál az ügyfelekkel, tanul a súgódokumentumokból és a korábbi beszélgetésekből, és azonnali, pontos válaszokat ad. Kezeli a kezdeti kérdéseket, és gyors megoldást nyújt, mielőtt szükség esetén átadja a beszélgetést egy ügynöknek."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumentumok",
      "ADD_NEW": "Új dokumentum létrehozása",
      "RELATED_RESPONSES": {
        "TITLE": "Kapcsolódó GYIK",
        "DESCRIPTION": "Ezek a GYIK-bejegyzések közvetlenül a dokumentumból készültek."
      },
      "FORM_DESCRIPTION": "Adja meg a dokumentum URL-jét, hogy tudásforrásként hozzáadja, és válassza ki a hozzá társítandó asszisztenst.",
      "CREATE": {
        "TITLE": "Dokumentum hozzáadása",
        "SUCCESS_MESSAGE": "A dokumentum létrehozása sikeres",
        "ERROR_MESSAGE": "Hiba történt a dokumentum létrehozásakor, próbálja újra."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Adja meg a dokumentum URL-jét",
          "ERROR": "Adjon meg érvényes URL-t a dokumentumhoz"
        },
        "ASSISTANT": {
          "LABEL": "Asszisztens",
          "PLACEHOLDER": "Asszisztens kiválasztása",
          "ERROR": "Az asszisztens megadása kötelező"
        }
      },
      "DELETE": {
        "TITLE": "Biztosan törölni szeretné a dokumentumot?",
        "DESCRIPTION": "Ez a művelet végleges. A dokumentum törlésével véglegesen törli az összes generált tudást.",
        "CONFIRM": "Igen, törlés",
        "SUCCESS_MESSAGE": "A dokumentum törlése sikeres",
        "ERROR_MESSAGE": "Hiba történt a dokumentum törlésekor, próbálja újra."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Kapcsolódó válaszok",
        "DELETE_DOCUMENT": "Dokumentum törlése"
      },
      "EMPTY_STATE": {
        "TITLE": "Nincs elérhető dokumentum",
        "SUBTITLE": "Az asszisztens a dokumentumokból generál GYIK-bejegyzéseket. Dokumentumok importálásával háttérinformációt adhat az asszisztensnek.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain dokumentum",
          "NOTE": "A Captainben a dokumentum tudásforrásként szolgál az asszisztens számára. Ha csatlakoztatja a súgóközpontot vagy az útmutatókat, a Captain elemzi a tartalmat, és pontos válaszokat ad az ügyfelek kérdéseire."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "GYIK",
      "ADD_NEW": "Új GYIK létrehozása",
      "DOCUMENTABLE": {
        "CONVERSATION": "Beszélgetés #{id}"
      },
      "SELECTED": "{count} kiválasztva",
      "BULK_APPROVE_BUTTON": "Jóváhagyás",
      "BULK_DELETE_BUTTON": "Törlés",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "A GYIK-bejegyzések jóváhagyása sikeres",
        "ERROR_MESSAGE": "Hiba történt a GYIK-bejegyzések jóváhagyásakor, próbálja újra."
      },
      "BULK_DELETE": {
        "TITLE": "Törli a GYIK-bejegyzéseket?",
        "DESCRIPTION": "Biztosan törölni szeretné a kiválasztott GYIK-bejegyzéseket? Ez a művelet nem vonható vissza.",
        "CONFIRM": "Igen, az összes törlése",
        "SUCCESS_MESSAGE": "A GYIK-bejegyzések törlése sikeres",
        "ERROR_MESSAGE": "Hiba történt a GYIK-bejegyzések törlésekor, próbálja újra."
      },
      "DELETE": {
        "TITLE": "Biztosan törölni szeretné a GYIK-bejegyzést?",
        "DESCRIPTION": "",
        "CONFIRM": "Igen, törlés",
        "SUCCESS_MESSAGE": "A GYIK-bejegyzés törlése sikeres",
        "ERROR_MESSAGE": "Hiba történt a GYIK-bejegyzés törlésekor, próbálja újra."
      },
      "FILTER": {
        "ASSISTANT": "Asszisztens: {selected}",
        "STATUS": "Státusz: {selected}",
        "ALL_ASSISTANTS": "Mind"
      },
      "STATUS": {
        "TITLE": "Státusz",
        "PENDING": "Függőben lévő",
        "APPROVED": "Jóváhagyva",
        "ALL": "Mind"
      },
      "FORM_DESCRIPTION": "Adjon hozzá egy kérdést és a hozzá tartozó választ a tudásbázishoz, és válassza ki a hozzá társítandó asszisztenst.",
      "CREATE": {
        "TITLE": "GYIK hozzáadása",
        "SUCCESS_MESSAGE": "A válasz hozzáadása sikeres.",
        "ERROR_MESSAGE": "Hiba történt a válasz hozzáadásakor. Próbálja újra."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Kérdés",
          "PLACEHOLDER": "Írja ide a kérdést",
          "ERROR": "Adjon meg érvényes kérdést."
        },
        "ANSWER": {
          "LABEL": "Válasz",
          "PLACEHOLDER": "Írja ide a választ",
          "ERROR": "Adjon meg érvényes választ."
        },
        "ASSISTANT": {
          "LABEL": "Asszisztens",
          "PLACEHOLDER": "Asszisztens kiválasztása",
          "ERROR": "Válasszon asszisztenst."
        }
      },
      "EDIT": {
        "TITLE": "GYIK frissítése",
        "SUCCESS_MESSAGE": "A GYIK-bejegyzés frissítése sikeres",
        "ERROR_MESSAGE": "Hiba történt a GYIK-bejegyzés frissítésekor, próbálja újra",
        "APPROVE_SUCCESS_MESSAGE": "A GYIK-bejegyzés jóváhagyottként megjelölve"
      },
      "OPTIONS": {
        "APPROVE": "Megjelölés jóváhagyottként",
        "EDIT_RESPONSE": "GYIK szerkesztése",
        "DELETE_RESPONSE": "GYIK törlése"
      },
      "EMPTY_STATE": {
        "TITLE": "Nem található GYIK",
        "SUBTITLE": "A GYIK segít az asszisztensnek gyors és pontos választ adni az ügyfelek kérdéseire. A bejegyzések automatikusan generálhatók a tartalmából, vagy kézzel is hozzáadhatók.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain GYIK",
          "NOTE": "A Captain GYIK felismeri az ügyfelek gyakori kérdéseit – akár hiányoznak a tudásbázisból, akár gyakran előfordulnak –, és releváns GYIK-bejegyzéseket generál a támogatás javításához. Minden javaslatot átnézhet, és eldöntheti, hogy jóváhagyja vagy elutasítja."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Csatlakoztatott postafiókok",
      "ADD_NEW": "Új postafiók csatlakoztatása",
      "OPTIONS": {
        "DISCONNECT": "Leválasztás"
      },
      "DELETE": {
        "TITLE": "Biztosan leválasztja a postafiókot?",
        "DESCRIPTION": "",
        "CONFIRM": "Igen, törlés",
        "SUCCESS_MESSAGE": "A postafiók leválasztása sikeres.",
        "ERROR_MESSAGE": "Hiba történt a postafiók leválasztásakor, próbálja újra."
      },
      "FORM_DESCRIPTION": "Válassza ki a postafiókot, amelyet az asszisztenshez csatlakoztat.",
      "CREATE": {
        "TITLE": "Postafiók csatlakoztatása",
        "SUCCESS_MESSAGE": "A postafiók csatlakoztatása sikeres.",
        "ERROR_MESSAGE": "Hiba történt a postafiók csatlakoztatásakor. Próbálja újra."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Fiók",
          "PLACEHOLDER": "Válassza ki a postafiókot, ahol az asszisztens működik.",
          "ERROR": "Postafiók kiválasztása kötelező."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nincs csatlakoztatott postafiók",
        "SUBTITLE": "Ha csatlakoztat egy postafiókot, az asszisztens kezeli az ügyfelek kezdeti kérdéseit, mielőtt átadja őket Önnek."
      }
    }
  }
}
